import React, { useEffect, useState } from 'react';

export default function PwaUpdatePrompt() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    let refreshing = false;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    navigator.serviceWorker.ready.then((registration) => {
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;

        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            setWaitingWorker(newWorker);
            setShow(true);
          }
        });
      });
    });

    navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration?.waiting) {
        setWaitingWorker(registration.waiting);
        setShow(true);
      }
    });
  }, []);

  const updateApp = () => {
    if (!waitingWorker) return;

    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-[360px] z-[99999]">
      <div className="rounded-3xl border border-white/10 bg-[#111827] text-white p-4 shadow-2xl">
        <div className="font-black text-base mb-2">
          نسخه جدید موجیم آماده است
        </div>

        <div className="text-sm text-slate-300 leading-7 mb-4">
          برای دریافت آخرین تغییرات، اپ را بروزرسانی کن.
        </div>

        <div className="flex gap-2">
          <button
            onClick={updateApp}
            className="flex-1 rounded-2xl bg-gradient-to-l from-blue-600 to-purple-600 py-3 font-bold"
          >
            بروزرسانی
          </button>

          <button
            onClick={() => setShow(false)}
            className="px-4 rounded-2xl border border-white/10 text-slate-300"
          >
            بعداً
          </button>
        </div>
      </div>
    </div>
  );
}